export default __webpack_public_path__ + "static/media/closeModal.ee9e88b3.svg";